import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type Props = {
  label: string;
  sublabel?: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  sublabel,
  id,
  className = ""
}: Props) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full flex-col items-center justify-center rounded-2xl bg-cta px-5 py-[18px] text-center text-white shadow-[0_6px_0_0_#0b7a37] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-[4px] active:shadow-[0_2px_0_0_#0b7a37] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold ${className}`} data-id="element-29" data-mp="cksp8iqpncgu">
      <span className="flex items-center justify-center gap-2 font-display text-[17px] font-black uppercase leading-tight tracking-tight [text-wrap:balance] sm:text-xl" data-id="element-30" data-mp="vclec22nsdja">
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="15ahnioc1cyer" />
      </span>
      {sublabel && <span className="mt-1 text-[13px] font-semibold opacity-95" data-id="element-32" data-mp="39yhn1mmcjfbq">{sublabel}</span>}
    </a>;
}